/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */

export enum DeliveryStatus {
  Open = 'Em aberto',
  Collected = 'Coletada',
  Delivered = 'Entregues',
  Unproductive = 'Improdutiva',
}

export enum RouteStatus {
  Scheduled = 'Programada',
  Pending = 'Pendente',
  Ongoing = 'Em andamento',
  Alert = 'Alerta',
  Finished = 'Finalizada',
  FinishedInOverdue = 'Finalizada com atraso',
  Overdue = 'Em atraso',
}

export enum ActivityStatus {
    Alert = 'Alerta',
    Scheduled = 'Programada',
    Pending = 'Pendente',
    Ongoing = 'Em andamento',
    OngoingTranshipment = 'Em transbordo',
    OngoingDispatch = 'Na transportadora',
    Overdue = 'Em atraso',
    Finished = 'Finalizada',
    FinishedInOverdue = 'Finalizada com atraso',
}

export enum GeneralStatus {
  Active = 'Ativo',
  Inactive = 'Inativo',
  Invited = 'Convidado',
}

export enum VehicleAccessoryStatus {
  Available = 'Disponível',
  Allocated = 'Alocado',
  Inactive = 'Inativo',
}
export enum TrainingStatus {
    Pending = 'Não iniciada',
    Ongoing = 'Em Andamento',
    InReview = 'Em Revisão',
    Finished = 'Finalizada',
  }

export enum FreightStatus {
    Collected = 'Coletada',
    Transhipment = 'Transbordada',
    Dispatch = 'Despachada',
    Delivered = 'Entregue',
    Unproductive = 'Improdutiva',
  }
